"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// Tailwind
require("./assets/stylesheets/tailwind.css");
// Additional Stylesheets
require("./assets/stylesheets/anchors.css");
require("./assets/stylesheets/accessibility.css");
require("./assets/stylesheets/colors.css");
require("./assets/stylesheets/icons.css");
require("./assets/stylesheets/typography.css");
require("./assets/stylesheets/work-sans.css");
require("./assets/stylesheets/footer.css");
require("./assets/stylesheets/testimonials.css");
require("./assets/stylesheets/billboard.css");
require("./assets/stylesheets/breadcrumbs.css");
require("./assets/stylesheets/forms.css");
require("./assets/stylesheets/facetwp.css");
require("./assets/stylesheets/megamenu.css");
require("./assets/stylesheets/menu.css");
require("./assets/stylesheets/wp-vars.css");
require("./assets/stylesheets/post-featured.css");
require("./assets/stylesheets/posts.css");
require("./assets/stylesheets/video.css");
require("./assets/stylesheets/content-spacing.css");
// Block Stylesheets
require("./blocks/block-quote/block-quote.css");
require("./blocks/columns/columns.css");
require("./blocks/heading/heading.css");
require("./blocks/paragraph/paragraph.css");
require("./blocks/list/list.css");
require("./blocks/table/table.css");
require("./blocks/separator/separator.css");
require("./assets/scripts/anchored_columns");
//Add lottie player support
require("@dotlottie/player-component");
// AlpineJs
const alpinejs_1 = __importDefault(require("alpinejs"));
const video_block_1 = __importDefault(require("./assets/scripts/video_block"));
const logo_slider_1 = __importDefault(require("./assets/scripts/logo_slider"));
const jump_links_1 = __importDefault(require("./assets/scripts/jump-links"));
const testimonial_slider_1 = __importDefault(require("./assets/scripts/testimonial_slider"));
alpinejs_1.default.data("logo_slider", logo_slider_1.default);
alpinejs_1.default.data("video_block", video_block_1.default);
alpinejs_1.default.data("testimonial_slider_block", testimonial_slider_1.default);
alpinejs_1.default.data("jump_links", jump_links_1.default);
alpinejs_1.default.start();
